import { Divider, Grid, IconButton, Stack, Typography } from '@mui/material';
import React, { useContext, useMemo } from 'react';
import { LanguageContext } from '../../../../../../../libs/Context';
import { MdOutlineModeEdit } from 'react-icons/md';
import PollSection from '../Components/PollSection';
import { getWeekDayAndDate } from '../../../../../../../libs/HelperContent';
import WebinarDesc from '../../WebinarRegistrationPreview/PreviewLeft/WebinarDesc';
import Speakers from './Speakers';
import Survey from './Survey';

const WebinarSummaryRight = (props) =>
{
	const { form, handleNavi } = props;
	const webinarDate = form?.startTimeUTC ? new Date(form?.startTimeUTC) : new Date();
	const { weekDay, dayOfMonth } = getWeekDayAndDate(webinarDate);

	const { language } = useContext(LanguageContext);

	const registrationFields = useMemo(() => form?.registrationFields?.map((item) => item?.field)?.join(', '), [ form?.registrationFields ]);

	return (

		<Grid container pl='var(--pixel12)'>
			<Grid item xs={12}>
				<Stack
					direction='row'
					alignItems='center'
				>
					<Stack direction={'column'} sx={{ borderRadius: 'var(--pixel8)', border: '1px solid var(--share)', textAlign: 'center', display: 'flex', flex: 'none', minWidth: 'var(--pixel24)' }}>
						<Typography sx={{ background: 'var(--shareTime)', color: 'var(--whiteColor)', borderRadius: '8px 8px 0px 0px', padding: '0px 10px 0px 10px', fontWeight: '500' }} variant='caption'>{weekDay || ''}</Typography>
						<Typography sx={{ padding: '0px 6px 0px 6px', fontWeight: '500', fontSize: 'var(--pixel18)' }}>{dayOfMonth || ''}</Typography>
					</Stack>
					<Stack direction={'row'} sx={{ paddingLeft: 'var(--pixel8)', display: 'flex', flex: 1, minWidth: 0 }} alignItems={'center'} justifyContent={'space-between'}>
						<Typography sx={{ width: 'var(--percent100)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} variant='inherit' color={'textPrimary'} fontWeight='var(--font500)'>{form?.meetingName}</Typography>
						<IconButton>
							<MdOutlineModeEdit color='var(--txtColorBlackL)' cursor={'pointer'} onClick={() => handleNavi(1)}/>
						</IconButton>
					</Stack>
				</Stack>
				<Typography variant='inherit' p='var(--pixel8)' mb={2}>
					<WebinarDesc description={form?.meetingDescription}/>
				</Typography>
			</Grid>
			<Grid item xs={12} pt='var(--pixel16)'>
				<Speakers meetingId={form?.id} handleNavi={handleNavi} form={form}/>
				<Divider sx={{ border: '1px solid #A3A3A3' }}/>
				<Grid container mb={3}>
					<Grid item xs={12}>
						<Stack direction={'column'} mt={3}>
							<Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
								<Typography sx={{ fontWeight: '600', fontSize: 'var(--pixel18)' }}>{form?.withRegistration ? 'With registration' : 'Without registration'}</Typography>
								<IconButton>
									<MdOutlineModeEdit color='var(--txtColorBlackL)' cursor={'pointer'} onClick={() => handleNavi(2)}/>
								</IconButton>
							</Stack>
							{(form?.withRegistration || (!form?.anonymousAccess && !form?.withRegistration)) && <Stack direction={'row'} mt={2}>
								<Typography fontWeight={'var(--font600)'} minWidth={'90px'}>Field:</Typography>
								<Typography pl='var(--pixel12)'>{registrationFields}</Typography>
							</Stack>}
							<Stack direction={'row'}>
								<Typography fontWeight={'var(--font600)'} minWidth={'90px'}>Moderation:</Typography>
								<Typography pl='var(--pixel12)'>
									{form?.moderation === 1
										? language?.registrationInfo
										: language?.registrationInfo2
									}
								</Typography>
							</Stack>
						</Stack>
					</Grid>
				</Grid>
				<PollSection meetingId={form?.id} handleNavi={handleNavi}/>
				<Survey meetingId={form?.id} handleNavi={handleNavi}/>
			</Grid>
		</Grid>

	);
};

export default WebinarSummaryRight;
